// Requirement R1: ΔH = 83,144 J/mol (or 83.144 kJ/mol), R = 8.3144 J/(mol·K) -> ΔH / R = 10,000 K
const ACTIVATION_ENERGY_J_MOL = 83144.0;
const GAS_CONSTANT_J_MOL_K = 8.3144;
const DH_OVER_R = 10000.0; // Named constant per implementation
const KV = 273.15; // °C to Kelvin

const calculateMkt = function (data) {
  if (!Array.isArray(data) || data.length === 0) {
    return undefined;
  }

  const newData = data.filter(item => typeof item === 'number' && Number.isFinite(item));
  const totalLen = newData.length;
  if (totalLen === 0) {
    return undefined;
  }

  let sumOfDenoms = 0;
  for (let i = 0; i < totalLen; i++) {
    const tempInKelvin = newData[i] + KV;
    if (tempInKelvin <= 0) {
      continue; // Guard against absolute zero or invalid sub-zero thermistor spikes
    }
    sumOfDenoms += Math.exp(-DH_OVER_R / tempInKelvin);
  }

  const meanExp = sumOfDenoms / totalLen;
  if (meanExp <= 0 || meanExp >= 1) {
    return undefined; // Guard against invalid log domain
  }

  const denominator = Math.log(meanExp) * -1;
  const mktVal = (DH_OVER_R / denominator) - KV;

  return mktVal;
};

export default calculateMkt;